import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { formatDate } from '@/utils/dateUtilities'
import Resx from '@/components/Resx'
import TopBarComments from '@/internal-app/components/comments/TopBarComments'
import { Link } from 'react-router-dom'
import { FileAttachments } from '@/components/fileAttachments'
import context from '@/context'
import Icon from '@/components/Icon'
import moment from 'moment'
import { TaskActivationButton } from '@/internal-app/components/tasks/taskActivationButton'
import { actionCreators } from '@/store/myActiveTask'
import { TaskResponseButtons } from '@/internal-app/pages/tasks/responseButtons'
import Name from '@/components/Name'
import { ChangeRequestItems } from './changeRequestItems'

const mapDispatchToProps = {
  activateTask: actionCreators.activateTask,
  deactivateTask: actionCreators.deactivateTask
}

@localized()
@connect(null, mapDispatchToProps)
class TopBarActiveTask extends React.Component {
  render () {
    const { task, activateTask, deactivateTask, onNavigate, activating, localizeValue, changeRequestItemsKey } = this.props
    return (
      <React.Fragment>
        <div className='active-task__header'>
          <div className='active-task-header__top'>
            <span className='time-created'>
              <time>{formatDate(task.creationTime)}</time>
            </span>
            <span className='time-due'>
              <Icon name='calendar-check' /> <time>{formatDate(task.dueDate)}</time>
            </span>
          </div>
          <div>
            <Link to={`/tasks/${task.id}`} onClick={onNavigate} className='active-task__title'><Name data={task} /></Link>
            <Link to={`/tickets/${task.ticketId}`} onClick={onNavigate}>
              <small className='task-ticket ellipsis'>
                <Icon name='list-alt' /> {task.ticketId}: {task.ticketName}
              </small>
            </Link>
          </div>
        </div>
        <div className='active-task__body'>
          <h3><Resx name='Tasks.Description' /></h3>
          <div className='cms-text'>
            <p dangerouslySetInnerHTML={{ __html: localizeValue(task.description, task.latinDescription) }} />
          </div>

          <h3><Resx name='Tasks.LastAttachment' /></h3>
          <FileAttachments attachments={getLastAttachments(task.attachments)} downloadAction={context.api.taskService.download} readonly />

          <TopBarComments task={task} />
          <hr />

          <div className='text-center mb-2'>
            <ChangeRequestItems key={changeRequestItemsKey} changeRequestId={task.changeRequestId} task={task} />
            <div className='active-task__event'>
              {task.status < 2 &&
                <TaskActivationButton showText taskId={task.id} activating={activating} activeTaskId={task.id}
                  onActivate={activateTask} onDeactivate={deactivateTask} />}
            </div>
            <div className='active-task__event'>
              <TaskResponseButtons useActiveTask />
            </div>
            <Link className='underline' to={`/tasks/${task.id}`} onClick={onNavigate}><Resx name='Tasks.TaskDetail' /></Link>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

function getLastAttachments (attachments) {
  return [...attachments].sort((a, b) => moment(b.creationTime).diff(moment(a.creationTime))).slice(0, 2)
}

export default TopBarActiveTask



// WEBPACK FOOTER //
// ./src/internal-app/components/tasks/TopBarActiveTask.js